<!--个人中心.我的众筹-->
<template>
  <div class="crowdfunding-mine">
    <fixed-header title="我的众筹"></fixed-header>
    <div class="crowdfunding-mine__navigator">
      <ul class="crowdfunding-mine__navigator-tab">
        <li
            :mg-stat-custom="`cont=我参与的&label=btn&addr=&direct=cntp`"
            mg-stat-click
            v-bind:class="curTabIndex === JOIN_INDEX?
                'crowdfunding-mine__navigator-tab-active':'crowdfunding-mine__navigator-tab-normal'"
            @click="changeActiveTab(JOIN_INDEX)"
        >我参与的
        </li>
        <li
            :mg-stat-custom="`cont=我关注的&label=btn&addr=&direct=cntp`"
            mg-stat-click
            v-bind:class="curTabIndex === FOLLOW_INDEX?
                'crowdfunding-mine__navigator-tab-active':'crowdfunding-mine__navigator-tab-normal'"
            @click="changeActiveTab(FOLLOW_INDEX)"
        >我关注的
        </li>
        <div ref="tabLine" class="crowdfunding-mine__navigator-tab-line"></div>
      </ul>
    </div>
    <div
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="loading"
        :infinite-scroll-distance="30"
        class="crowdfunding-mine__container scroll-touch"
    >
      <fragment-crowdfunding-join v-show="curTabIndex === JOIN_INDEX" v-bind:items="list"></fragment-crowdfunding-join>
      <fragment-crowdfunding-follow v-if="curTabIndex === FOLLOW_INDEX"
                                    v-bind:items="list"></fragment-crowdfunding-follow>
      <div v-if="showEmpty">
        <img src="../../../assets/img/empty_icon.png"/>
        <p>暂无{{ curTabIndex === JOIN_INDEX ? "参与" : "关注" }}的众筹哦~</p>
      </div>
    </div>
  </div>
</template>

<script>
import FixedHeader from '../../../components/common/FixedHeader/index';
import FragmentCrowdfundingFollow from '../../../components/crowdfunding/mine/follow/index';
import FragmentCrowdfundingJoin from '../../../components/crowdfunding/mine/join/index';
import { crowdfollowLadderList, crowdJoinLadderList } from 'apis/crowdfunding';

export default {
  name: 'index',
  components: {
    FragmentCrowdfundingJoin,
    FragmentCrowdfundingFollow,
    FixedHeader,
  },
  data() {
    return {
      JOIN_INDEX: 0,
      FOLLOW_INDEX: 1,
      curTabIndex: 0,
      loading: false, // 是否正在加载
      disableLoad: false, // 是能继续加载
      list: [],
      showEmpty: false,
      page: 1,
      totalPages: 1,
    };
  },
  mounted() {
    this.pageList();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    changeActiveTab(tabIndex) {
      this.scrollToTop();
      const tabLine = this.$refs.tabLine;
      if (tabIndex === this.JOIN_INDEX) {
        tabLine.style.left = '22.5%';
      } else if (tabIndex === this.FOLLOW_INDEX) {
        tabLine.style.left = '72.7%';
      }
      this.page = 1;
      this.curTabIndex = tabIndex;
      this.list = [];
      this.pageList();
    },
    async pageList() {
      this.loading = true;
      try {
        const data =
            this.curTabIndex === this.FOLLOW_INDEX
              ? await crowdfollowLadderList({ p: this.page, limit: 5 })
              : await crowdJoinLadderList({ p: this.page, limit: 5 });
        if (data) {
          this.totalPages = data.totalPage;
          const _list = data.list;
          this.list = [...this.list, ..._list];
          if (this.page === 1) {
            this.showEmpty = _list == null || _list.length === 0;
          }
        }
      } catch (e) {
        const { message } = e;
        console.error(`获取关注列表失败:${message}`, e.toString());
      } finally {
      }
      this.loading = false;
    },
    loadMore() {
      if (this.totalPages > this.page) {
        this.page++;
        this.pageList();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$page_width: 750px;
.crowdfunding-mine {
  width: $page_width;
  height: 100%;
  background: rgb(246, 246, 246);

  &__navigator {
    z-index: 100;
    position: fixed;
    border-radius: 0px 0px 20px 20px;
    background: white;
    width: $page_width;
    height: 79px;

    &-tab {
      position: relative;
      height: 100%;
      width: $page_width;
      display: flex;
      align-items: center;
      justify-content: center;

      li {
        display: flex;
        justify-content: center;
        width: 50%;
        font-size: 26px;
      }

      &-active {
        color: rgb(35, 35, 35);
        font-weight: bold;
      }

      &-normal {
        color: rgb(128, 128, 128);
      }

      &-line {
        width: 32px;
        height: 4px;
        text-align: center;
        position: absolute;
        top: 60px;
        flex: 1;
        left: 22.5%;
        transition: 0.3s ease-in-out;
        background: linear-gradient(
                112deg,
                rgba(255, 25, 25, 1),
                rgba(255, 88, 30, 1)
        );
      }
    }
  }

  &__container {
    position: relative;
    top: 90px;
    width: 100%;
    height: 100%;

    p {
      text-align: center;
      font-size: 28px;
      color: #A8A8A8FF;
    }

    img {
      height: 122px;
      width: 122px;
      margin-left: 314px;
      margin-top: 358px;
    }
  }
}
</style>
